import React, {useEffect, useState, useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import cfg, {courses, formatErrors, roleAdmin, roleTechnicalSpecialist, roleCurator} from '../../constants';
import {toast} from 'react-toastify';
import {InputDate} from '../../utils/inputSearch/InputDate';
import {SortItem} from '../../utils/sortItem/SortItem';
import {Pagination} from '../../utils/pagination/Pagination';
import {getShiftControlAction} from "../../actions/usersAction";
import {MenuHeader} from "../../utils/menu/MenuHeader";

const ShiftControl = (props) => {
  let nowDate = new Date();
  let nowDateStr = nowDate.toISOString().split('T')[0];

  const {user, isAdmin, getClients, isTechnicalSpecialist} = props;
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({date: nowDateStr});
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const abortRef = useRef(null);

  const handleChangeFilter = useCallback((field, value) => {
    setFilter((data) => {
      return {...data, [field]: value, page: 1}
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  const handleChangeSort = useCallback((sort, sortd) => {
    setFilter((data) => {
      return {...data, sort, sortd}
    });
  }, []);

  // get clients list
  const getClientsList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    setLoading(true)
    getClients(filter, isAdmin, abortRef && abortRef.current ? abortRef.current.signal : null, isTechnicalSpecialist).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      setChecked({});
      setCheckedAll(false);
      setLoading(false)
      //localStorage.setItem('dc_currentShiftControlFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [getClients, isAdmin, isTechnicalSpecialist]);

  const handleChecked = (id) => {
    let values = {...checked};
    if (values.hasOwnProperty(id) && values[id]) {
      delete values[id];
      setChecked(values);
      setCheckedAll(false);
    } else {
      values[id] = true;
      setChecked(values);
      setCheckedAll(items.filter(i => i.id !== id && !checked[i.id]).length === 0);
    }
  };

  const handleCheckedAll = () => {
    setCheckedAll(!checkedAll);
    setChecked(checkedAll ? {} : items.reduce((res, i) => {
      res[i.id] = true;
      return res;
    }, {}));
  };

  // get clients list on change filter
  useEffect(() => {
    if (filter.page) {
      getClientsList(filter);
    }

  }, [filter, getClientsList]);

  useEffect(() => {
    if (!user || !user.id) {
      return;
    }
    const baseFilter = {page: 1, limit: 10, date: nowDateStr};
    //let curFilter = localStorage.getItem('dc_currentShiftControlFilter');
    //curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    let curFilter = baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    if (user.role_id === roleCurator) {
      curFilter.curator_id = user.id;
    } else {
      curFilter.curator_id = "";
    }
    setFilter(curFilter);
  }, [user]);

  return <div className="content">
    <Menu isStatic={user.role_id === roleCurator ? false : true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Контроль смен</h2>
      <div className="heading__group">
        
      </div>

      {loading && <img src="/img/Spinner-2.gif" />}

      {filter.page && filter.page > 0 && <InputDate className=""
                                                          value={filter.date}
                                                          loading={loading}
                                                          handleChange={handleChangeFilter} placeholder={"Дата"} name={"date"} />}
    </div>

    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Фио куратора" className="sort__item--name" sort="curators_name" sortd={filter.sort === "curators_name" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Время первого ответа" className="sort__item--name" sort="first_response_time" sortd={filter.sort === "first_response_time" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Время последнего ответа" className="sort__item--name" sort="last_response_time" sortd={filter.sort === "last_response_time" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Количество неотвеченных сообщений на конец смены" className="sort__item--name" sort="number_unanswered_messages_end_shift" sortd={filter.sort === "number_unanswered_messages_end_shift" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Средняя длительность смены" className="sort__item--name" sort="average_shift_duration" sortd={filter.sort === "average_shift_duration" ? filter.sortd : ""} onChange={handleChangeSort}/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <span className="users__name">{i.last_name} {i.first_name}</span>
              <span className="users__name">{i.first_response_time}</span>
              <span className="users__name">{i.last_response_time}</span>
              <span className="users__name">{i.number_unanswered_messages_end_shift}</span>
              <span className="users__name">{i.average_shift_duration}</span>
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile,
  isAdmin: state.user.profile && state.user.profile.role_id === roleAdmin,
  isTechnicalSpecialist: state.user.profile && state.user.profile.role_id === roleTechnicalSpecialist
});

const mapDispatchToProps = (dispatch) => {
  return {
    getClients(data, isAdmin, signal) {
      return dispatch(getShiftControlAction(data, signal));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShiftControl))
